'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Modal = require('@cimpress/react-components/lib/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _formatDuration = require('format-duration');

var _formatDuration2 = _interopRequireDefault(_formatDuration);

var _lodash = require('lodash.isfinite');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var roundTime = function roundTime(time) {
  return Math.round(time / 1000) * 1000;
}; // TODO: make https://translations.cimpress.io


var TEXT = {
  countdown: 'Your authentication token is about to expire',
  expired: 'Your authentication token has expired',
  warningMessage: 'Any unsaved work may be lost if not saved before your token expires.',
  expiredMessage: 'Any unsaved work may have been lost. Please log in again to continue working.',
  dismiss: 'Dismiss',
  login: 'Log In'
};

var AuthTokenExpired = function (_PureComponent) {
  _inherits(AuthTokenExpired, _PureComponent);

  function AuthTokenExpired() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AuthTokenExpired);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AuthTokenExpired.__proto__ || Object.getPrototypeOf(AuthTokenExpired)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      show: false,
      enableButtons: false,
      expiresAt: undefined,
      timeLeft: undefined
    }, _this.show = function (expiresAt) {
      window.clearTimeout(_this.enable);
      var now = new Date().getTime();
      var timeLeft = roundTime(expiresAt - now);

      _this.setState({
        show: true,
        enableButtons: false,
        expiresAt: expiresAt,
        timeLeft: timeLeft
      }, (0, _lodash2.default)(timeLeft) && _this.startCountdown);

      _this.enable = window.setTimeout(function () {
        return _this.setState({
          enableButtons: true
        });
      }, _this.props.enabledDelay * 1000);
    }, _this.hide = function () {
      return _this.setState({
        show: false
      });
    }, _this.onAuthenticated = function (source) {
      _this.hide();

      switch (source) {
        case 'storage':
          _this.props.onExternalLogin();

        default:
      }
    }, _this.dismiss = function () {
      _this.hide();

      _this.props.onDismiss();
    }, _this.login = function () {
      window.clearInterval(_this.countdown);

      _this.hide();

      _this.props.onLogin();
    }, _this.startCountdown = function () {
      window.clearInterval(_this.countdown);
      _this.countdown = window.setInterval(_this.updateTimeLeft, 1000);
    }, _this.updateTimeLeft = function () {
      var now = new Date().getTime();
      var timeLeft = roundTime(_this.state.expiresAt - now);
      var state = {
        timeLeft: timeLeft
      };

      if (timeLeft <= 0) {
        window.clearInterval(_this.countdown);
        state.show = true;
      }

      _this.setState(state);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AuthTokenExpired, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.authWrapper.on('tokenExpired', this.show);
      this.props.authWrapper.on('authenticated', this.onAuthenticated);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.authWrapper.removeListener('tokenExpired', this.show);
      this.props.authWrapper.removeListener('authenticated', this.onAuthenticated);
      window.clearInterval(this.countdown);
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          show = _state.show,
          timeLeft = _state.timeLeft,
          enableButtons = _state.enableButtons;
      var children = this.props.children;
      var countdown = TEXT.countdown,
          expired = TEXT.expired,
          dismiss = TEXT.dismiss,
          login = TEXT.login,
          warningMessage = TEXT.warningMessage,
          expiredMessage = TEXT.expiredMessage;
      var isNumeric = (0, _lodash2.default)(timeLeft);
      var isCountingDown = isNumeric && timeLeft > 0;
      var title = isCountingDown ? _react2.default.createElement('span', null, countdown, ' ', _react2.default.createElement('span', {
        className: 'text-danger'
      }, (0, _formatDuration2.default)(timeLeft))) : _react2.default.createElement('span', null, expired);

      var footer = _react2.default.createElement(_react.Fragment, null, _react2.default.createElement('button', {
        className: 'btn btn-default',
        disabled: !enableButtons,
        onClick: this.dismiss
      }, dismiss), _react2.default.createElement('button', {
        className: 'btn btn-outline-secondary',
        disabled: !enableButtons,
        onClick: this.login
      }, login));

      return _react2.default.createElement(_Modal2.default, {
        show: show,
        bsSize: 'lg',
        bsStyle: 'danger',
        title: title,
        footer: footer
      }, _react2.default.createElement('p', null, isCountingDown ? warningMessage : expiredMessage), children && _react2.default.createElement('div', {
        style: {
          marginBottom: '20px'
        }
      }), children);
    }
  }]);

  return AuthTokenExpired;
}(_react.PureComponent);

AuthTokenExpired.propTypes = {
  authWrapper: _propTypes2.default.any.isRequired,
  onLogin: _propTypes2.default.func,
  onExternalLogin: _propTypes2.default.func,
  onDismiss: _propTypes2.default.func,
  enabledDelay: _propTypes2.default.number
};
AuthTokenExpired.defaultProps = {
  enabledDelay: 3,
  onLogin: function onLogin() {},
  onExternalLogin: function onExternalLogin() {},
  onDismiss: function onDismiss() {}
};
exports.default = AuthTokenExpired;